import { render } from "./SegmentosInstView.vue?vue&type=template&id=753fe79e&scoped=true"
import script from "./SegmentosInstView.vue?vue&type=script&lang=js"
export * from "./SegmentosInstView.vue?vue&type=script&lang=js"

import "./SegmentosInstView.vue?vue&type=style&index=0&id=753fe79e&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD26\\ConfiguradorSistema\\FrontBackEndVue\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753fe79e"]])

export default __exports__